import React, { useEffect, useState } from "react";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";


/* -------------------- STATIC OPTIONS -------------------- */

const departmentOptions = [
  { value: "Langar", label: "Langar" },
  { value: "Canteen", label: "Canteen" },
];

/* -------------------- COMPONENT -------------------- */

const Recipe = () => {
  const centerCode = localStorage.getItem("code");
  const token = localStorage.getItem("token");

  /* -------------------- STATES -------------------- */

  const [creation, setCreation] = useState("");
  const [persons, setPersons] = useState("");
  const [department, setDepartment] = useState(null);
  const [producedQty, setProducedQty] = useState("");
  const [uomOptions, setUomOptions] = useState([]);
  const [producedUom, setProducedUom] = useState(null);
  const [loadingData, setLoadingData] = useState(false);
  const sewadarId = localStorage.getItem("sewadarId");
  
  const [inventoryOptions, setInventoryOptions] = useState([]);
  const location = useLocation();
const navigate = useNavigate();

const recipeId = location.state?.id;
const isEdit = Boolean(recipeId);

  const [items, setItems] = useState([
    { item: null, itemName: "", uom: "", qty: "" },
  ]);

  /* -------------------- HANDLERS -------------------- */
  const fetchUOMs = async () => {
    try {
      setLoadingData(true);
  
      const response = await apiClient.get(
        `${SERVER_BASE}/getUoms`,
        {
          params: { code: centerCode },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      const options = response.data.map((uom) => ({
        value: uom.abbreviation,                // ✅ value = id
        label: `${uom.abbreviation} - ${uom.unit}`,      // ✅ label = abbreviation
      }));
  
      setUomOptions(options);
    } catch (error) {
      console.error("Error fetching UOMs:", error);
    } finally {
      setLoadingData(false);
    }
  };
  
  const fetchRecipeById = async () => {
    try {
      const res = await apiClient.get(
        `${SERVER_BASE}/getRecipe/${recipeId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      const r = res.data;
  
      setDepartment({ value: r.department, label: r.department });
      setCreation(r.producingItem);
      setProducedQty(r.producingQty);
      setProducedUom(
        r.producingUom
          ? { value: r.producingUom, label: r.producingUom }
          : null
      );
      setPersons(r.persons || "");
  
      setItems(
        r.items.map((i) => ({
          item: i.itemId,
          itemName: i.itemName,
          uom: i.uom,
          qty: i.qty,
        }))
      );
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to load recipe", "error");
    }
  };
  
  const handleChange = (index, field, value) => {
    setItems((prevRows) =>
      prevRows.map((row, i) => {
        if (i !== index) return row;

        const updatedRow = {
          ...row,
          [field]: value?.value ?? value,
        };

        // Auto-fill UOM on item selection
        if (field == "item") {
            const selectedInventory = inventoryOptions.find(
              (opt) => opt.value == value?.value
            );
          
            updatedRow.uom = selectedInventory?.uom || "";
            updatedRow.itemName = selectedInventory?.label  || ""; // ✅ ADD
          }
          

        return updatedRow;
      })
    );
  };

  const addRow = () => {
    setItems((prev) => [
      ...prev,
      { item: null, itemName: "", uom: "", qty: "" },
    ]);
  };

  const removeRow = (index) => {
    setItems((prev) => prev.filter((_, i) => i !== index));
  };

  /* -------------------- API -------------------- */

  const fetchInventory = async () => {
    try {
      const groupCodes = ["G", "O", "F", "D"];
      const selectedTypeValues = ["Consumables"];

      const response = await apiClient.get(
        `${SERVER_BASE}/getItemsByGroupAndItem`,
        {
          params: {
            groupCodes,
            selectedTypeValues,
            code: centerCode,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.map((inventory) => ({
        value: inventory.id,
        label: `${inventory.printName}${
          inventory.additionalNames ? ` - [ ${inventory.additionalNames} ]` : ""
        }`,
        uom: inventory.uom,
        itemName: inventory.printName, // ✅ ADD THIS
      }));
      

      setInventoryOptions(options);
    } catch (error) {
      console.error("Error fetching inventory:", error);
    }
  };
  useEffect(() => {
    fetchInventory();
    fetchUOMs();
  
    if (isEdit) {
      fetchRecipeById();
    }
  }, [recipeId]);

  const handleSubmit = async () => {
    try {
      if (!department) {
        Swal.fire({
          icon: "warning",
          toast: true,
          position: "top-end",
          text: "Department is required",
          timer: 1500,
          showConfirmButton: false,
        });
        return;
      }
      if (!creation) {
        Swal.fire({
          icon: "warning",
          toast: true,
          position: "top-end",
          text: "Producing Item is required",
          timer: 1500,
          showConfirmButton: false,
        });
        return;
      }
      if (!persons && !producedQty) {
        Swal.fire({
          icon: "warning",
          toast: true,
          position: "top-end",
          text: "Person or Producing qty is required",
          timer: 1500,
          showConfirmButton: false,
        });
        return;
      }
      if (producedQty && !producedUom) {
        Swal.fire({
          icon: "warning",
          toast: true,
          position: "top-end",
          text: "UOM is required!",
          timer: 1500,
          showConfirmButton: false,
        });
        return;
      }
      // if (!department || !creation || !producedQty) {
      //   Swal.fire({
      //     icon: "warning",
      //     toast: true,
      //     position: "top-end",
      //     text: "Please fill required fields",
      //     timer: 1500,
      //     showConfirmButton: false,
      //   });
      //   return;
      // }
  
      if (!items.length) {
        Swal.fire({
          icon: "warning",
          toast: true,
          position: "top-end",
          text: "Add at least one item",
          timer: 1500,
          showConfirmButton: false,
        });
        return;
      }
  
      const payload = {
        department: department.value,
        producingItem: creation,
        producingQty: Number(producedQty),
        producingUom: producedUom?.value,
        persons: Number(persons),
        sewadarId:sewadarId,
        items: items.map((row) => ({
          itemId: row.item,
          itemName: row.itemName,
          uom: row.uom,
          qty: Number(row.qty),
        })),
      };
  
      let res;
  
      if (isEdit) {

        res = await apiClient.put(
          `${SERVER_BASE}/updateRecipe/${recipeId}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        res = await apiClient.post(
          `${SERVER_BASE}/saveRecipe`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
  
      Swal.fire({
        icon: "success",
        toast: true,
        position: "top-end",
        text: res?.data?.message,
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
      });
  
      // OPTIONAL: redirect back to list
      navigate("../RecipeList");
  
    } catch (error) {
      console.error("Error saving recipe:", error);
      Swal.fire({
        icon: "error",
        toast: true,
        position: "top-end",
        text: "Something went wrong",
        timer: 1500,
        showConfirmButton: false,
      });
    }
  };
  

  /* -------------------- UI -------------------- */

  return (
    <div className="formcontainer mt-5">
      <div className="d-flex gap-3 ">
      <button
              className="btn btn-sm btn-success"
              onClick={() => {
                navigate("../RecipeList");
              }}
            >
              Back
            </button>
      <h4 className="">Recipe Creation</h4>
      </div>
      <div className="row mb-3 align-items-end">
      <div className="col-md-2">
          <label className="form-label">Department</label>
          <Select
            options={departmentOptions}
            value={department}
            onChange={setDepartment}
            placeholder="Select Department"
            isClearable
          />
        </div>
        <div className="col-md-2">
          <label className="form-label">
          Produced Item
          </label>
          <input
            type="text"
            className="form-control"
            value={creation}
            onChange={(e) => setCreation(e.target.value)}
          />
        </div>

        <div className="col-md-2">
          <label className="form-label">
            Persons
          </label>
          <input
            type="number"
            className="form-control"
            value={persons}
            onChange={(e) => setPersons(e.target.value)}
          />
        </div>


    
        <div className="col-md-2">
          <label className="form-label">Qty to be Produced</label>
          <input
            type="number"
            className="form-control"
            value={producedQty}
            onChange={(e) => setProducedQty(e.target.value)}
          />
        </div>
        <div className="col-md-2">
  <label className="form-label">Produced UOM</label>
  <Select
    options={uomOptions}
    value={producedUom}
    onChange={setProducedUom}
    placeholder="Select UOM"
    isLoading={loadingData}
    isClearable
  />
</div>
<div className="col-md-2 ">
  <button
    className="btn btn-success"
    onClick={handleSubmit}
  >
    Submit
  </button>
</div>
      </div>

      {/* -------------------- ITEMS TABLE -------------------- */}

      <table className="table table-bordered">
        <thead className="table-light">
          <tr>
            <th style={{ width: "35%" }}>Item</th>
            <th style={{ width: "20%" }}>Qty</th>
            <th style={{ width: "20%" }}>UOM</th>
            <th style={{ width: "25%" }}>Action</th>
          </tr>
        </thead>

        <tbody>
          {items.map((row, index) => (
            <tr key={index}>
              <td>
                <Select
                  options={inventoryOptions}
                  value={inventoryOptions.find(
                    (i) => i.value == row.item
                  )}
                  onChange={(val) =>
                    handleChange(index, "item", val)
                  }
                  placeholder="Select Item"
                  isClearable
                />
              </td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  value={row.qty}
                  onChange={(e) =>
                    handleChange(index, "qty", e.target.value)
                  }
                />
              </td>

              <td>
                <input
                  type="text"
                  className="form-control"
                  value={row.uom}
                  disabled
                />
              </td>


              <td>
                <button
                  className="btn btn-sm btn-success me-2"
                  onClick={addRow}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </button>

                {items.length > 1 && (
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => removeRow(index)}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    

    </div>
  );
};

export default Recipe;
